import { Platform, ViewStyle } from 'react-native';

type WebOnlyStyles = {
  cursorPointer: ViewStyle;
  cursorDefault: ViewStyle;
  noSelect: ViewStyle;
  transition: (property?: string, duration?: string, easing?: string) => ViewStyle;
  backdropBlur: (radius?: number) => ViewStyle;
};

const webStyles: WebOnlyStyles = {
  cursorPointer: { cursor: 'pointer' } as any,
  cursorDefault: { cursor: 'default' } as any,
  noSelect: { userSelect: 'none' } as any,
  transition: (property = 'all', duration = '0.15s', easing = 'ease') =>
    ({ transition: `${property} ${duration} ${easing}` }) as any,
  backdropBlur: (radius = 16) => ({
    backdropFilter: `blur(${radius}px)`,
    WebkitBackdropFilter: `blur(${radius}px)`,
  }) as any,
};

const emptyProxy: WebOnlyStyles = {
  cursorPointer: {},
  cursorDefault: {},
  noSelect: {},
  transition: () => ({}),
  backdropBlur: () => ({}),
};

export const WEB_STYLES: WebOnlyStyles = Platform.OS === 'web' ? webStyles : emptyProxy;
